import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SetArrayDataCheckBoks } from "../../../Redux/Reducers/Shared/CheckBox";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";

const SetEvaluter = () => {
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks
  );
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "firstName",
      ShowStatus: true,
      NmaeColumn: "اسم المحكم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "email",
      ShowStatus: true,
      NmaeColumn: "البريد الإلكتروني",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        // setSecondarySectorsId(e.target.value);

        let value = JSON.parse(e.target.value).userGuid;

        navigate(`/ResearchersAward/manager/SetEvaluter/${value}`);
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };
  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(SetArrayDataCheckBoks());
  }, []);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"userGuid"}
        valueButtonAction={"userGuid"}
        URL={`api/Evaluator/GetAllEvaluatorList`}
        UrlBody={{}}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"أعضاء التحكيم"}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"taskId"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};

export default SetEvaluter;
